// Pieces of the top-bar X account switcher (app/Layout.tsx): an avatar with a status dot,
// and one menu row per account (handle, followers, type, status, the browser that runs it).

import type { IgAccount } from "@gmx/shared";
import { Avatar } from "@gmx/ui";
import { accountRunState, runStateLabel, shortRunLine } from "../../lib/accountStatus";
import { formatCount } from "../../lib/format";
import { accountTypeLabel } from "../AccountTypeBadge";
import { RunDot } from "./IgRunStatus";
import "./ig-workspaces.css";

/** Avatar with the account's run-status dot in the corner. */
export function IgStatusAvatar({ account, size, ring }: { account: IgAccount; size: number; ring?: boolean }) {
  return (
    <span className="gfp-ws-avatar">
      <Avatar src={account.profilePicUrl} name={account.fullName || account.username} size={size} ring={ring} />
      <RunDot state={accountRunState(account)} label={runStateLabel(account)} className="gfp-ws-avatar__dot" />
    </span>
  );
}

/** Menu row label: @handle / followers · type / ● status · browser. */
export function IgSwitcherOption({ account }: { account: IgAccount }) {
  const state = accountRunState(account);
  return (
    <span className="gfp-switcher__option">
      <span className="gfp-switcher__optname">@{account.username}</span>
      <span className="gfp-switcher__optmeta">
        {formatCount(account.followers)} followers · {accountTypeLabel(account.accountType)}
      </span>
      <span className={`gfp-ws-switch__status gfp-ws-switch__status--${state}`}>
        <RunDot state={state} />
        <span className="gfp-ws-switch__statustext">{shortRunLine(account)}</span>
      </span>
    </span>
  );
}
